import { render, staticRenderFns } from "./TrGame.vue?vue&type=template&id=37e09659&scoped=true&"
import script from "./TrGame.vue?vue&type=script&lang=js&"
export * from "./TrGame.vue?vue&type=script&lang=js&"
import style0 from "./TrGame.vue?vue&type=style&index=0&id=37e09659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e09659",
  null
  
)

export default component.exports